import * as React from "react";
import Loader from "../core/Loader";
import { moneyFormatter } from "../../utils";
import { useCommissionMonths } from "./common";
import Select from "react-select";
import * as moment from "moment";
import { Link } from "react-router-dom";
import { get } from "lodash";
import MonthStatusLabel from "./MonthStatusLabel";
import { useEffect, useState } from "react";
import styled from "styled-components";

const PendingApprovalSectionContainer = styled.div`
  padding: 10px;
  background-color: #e6eff2;
  margin-bottom: 10px;
`;

const YourCommmissionsSectionContainer = styled.div`
  margin-top: 5px;
`;

const PendingApprovalSectionTitle = styled.div`
  padding: 5px 0;
  font-size: 20px;
  width: 100%;
`;

const YourCommissionsSectionTitle = styled.div`
  padding: 5px 0;
  font-size: 20px;
  width: 100%;
  margin: 5px 0;
`;

const cformat = num => (num ? moneyFormatter.format(num) : "");

function EmployeeCommissionsTable({ user, commissions }) {
  const { years, setYear, possibleMonths, year } = useCommissionMonths();

  const [loading, setLoading] = useState(true);

  const [pendingApprovalCommissions, setPendingApprovalCommissions] = useState(
    []
  );

  useEffect(() => {
    if (commissions) {
      setLoading(false);
      const commissionsReadyForApproval = commissions.filter(
        c => c.userApproval === "ready_for_approval"
      );
      if (
        commissionsReadyForApproval &&
        Array.isArray(commissionsReadyForApproval) &&
        commissionsReadyForApproval.length > 0
      ) {
        setPendingApprovalCommissions(commissionsReadyForApproval);
      }
    }
  }, [commissions]);

  if (loading) {
    return <Loader />;
  }

  const months = possibleMonths.map(month => {
    const commission = commissions.find(
      com => moment(com.month).month() === month.index
    );

    return (
      <tr key={`${year}-${month.index}`}>
        <td>
          {month.name} {year}
        </td>
        <td>{cformat(get(commission, "resultCache.total"))}</td>
        <td>
          {commission && (
            <MonthStatusLabel userApprovalStatus={commission.userApproval} />
          )}
        </td>
        <td>
          {commission ? (
            <Link
              className={"btn btn-default btn-sm"}
              to={`/commissions/${commission.id}`}
            >
              <i className="fa fa-eye" /> View
            </Link>
          ) : (
            "Not Created Yet"
          )}
        </td>
      </tr>
    );
  });

  const pendingApprovalCommissionsSection =
    pendingApprovalCommissions.length > 0 ? (
      <PendingApprovalSectionContainer>
        <PendingApprovalSectionTitle>
          Your approval required:
        </PendingApprovalSectionTitle>
        <table className="table">
          <thead>
            <tr>
              <th>Month</th>
              <th>Total</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {pendingApprovalCommissions.map(month => {
              return (
                <tr key={`${month.id}`}>
                  <td>{moment(month.month).format("MMMM YYYY")}</td>
                  <td>{cformat(get(month, "resultCache.total"))}</td>
                  <td>
                    <MonthStatusLabel userApprovalStatus={month.userApproval} />
                  </td>
                  <td>
                    <Link
                      className={"btn btn-default btn-sm"}
                      to={`/commissions/${month.id}`}
                    >
                      <i className="fa fa-eye" /> View
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </PendingApprovalSectionContainer>
    ) : null;

  return (
    <>
      {pendingApprovalCommissionsSection}
      <YourCommmissionsSectionContainer>
        <YourCommissionsSectionTitle>
          View commissions by month:
        </YourCommissionsSectionTitle>
        <Select
          value={{ label: year.toString(), value: year }}
          options={years.current.map(y => ({
            label: y.toString(),
            value: y,
          }))}
          onChange={(opt: ISelectOption) => setYear(opt.value)}
          clearable={false}
        />
        <table className="table">
          <thead>
            <tr>
              <th>Month</th>
              <th>Total</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>{months}</tbody>
        </table>
      </YourCommmissionsSectionContainer>
    </>
  );
}

export default EmployeeCommissionsTable;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/EmployeeCommissionsTable.tsx